const removePriceSubstring = str => {
  const index = str.indexOf('(');
  if (index !== -1) {
    return str.substring(0, index);
  }
  return str;
};

export default removePriceSubstring;
